import { apiFetch, apiFetchShopper } from "./api";

export function createProduct(data) {
  return apiFetch("/products", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function getProducts() {
  return apiFetch("/products/me");
}

export function deleteProduct(productId) {
  return apiFetch(`/products/${productId}`, {
    method: "DELETE",
  });
}

export function bulkDeleteProducts(productIds) {
  return apiFetch("/products/bulk-delete", {
    method: "POST",
    body: JSON.stringify({ product_ids: productIds }),
  });
}

export function updateProductActive(productId, isActive) {
  return apiFetch(`/products/${productId}/active`, {
    method: "PATCH",
    body: JSON.stringify({ is_active: isActive }),
  });
}

export function getProductTryOnDiagnostics(productId) {
  return apiFetch(`/products/${productId}/tryon-diagnostics`);
}

export function getPublicProducts(country = null) {
  const query = country ? `?country=${encodeURIComponent(country)}` : "";
  return apiFetchShopper(`/products/public${query}`);
}

export async function getPublicProduct(productId, country = null) {
  const data = await getPublicProducts(country);
  const products = Array.isArray(data) ? data : data?.products || [];
  return products.find((p) => String(p.id) === String(productId)) || null;
}

export async function updateProductTryOn(productId, payload) {
  const res = await apiFetch(`/products/${productId}/try-on`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

  return res;
}

export function recomputeProductMask(productId) {
  return apiFetch(`/products/${productId}/recompute-mask`, {
    method: "POST",
  });
}